import { InternalOrganizationBillingEventType } from '@/api/v1/organization/internal/getInternalOrganizationBillingEventsApi';
import { UtcTooltip } from '@/components/UtcTooltip/UtcTooltip';
import { TableConfigItemsListType } from '@/components/Table/types/types';
import { WIRE_TYPE_SINGULAR_LABEL } from '@/const/wire';
import { formatDateTimeUTC } from '@/helpers/dateHelpers/dateHelpers';
import CheckedIcon from '@/images/CheckSmallIcon.svg?react';
import DashedIcon from '@/images/DashIcon.svg?react';

export const MASTER_ADMIN_BILLING_EVENTS_CONFIG: TableConfigItemsListType<InternalOrganizationBillingEventType> = [
  {
    key: 1,
    name: 'date_created',
    header: 'BILLABLE EVENT DATE',
    width: '15%',
    tooltip: <UtcTooltip message='Billable Event Date is recorded in UTC.' />,
    hasSort: true,
    getValue({ date_created }) {
      const date = formatDateTimeUTC(date_created);

      return { value: date, title: date };
    },
  },
  {
    key: 2,
    name: 'wire__name,-date_created',
    header: 'WIRE NAME',
    width: '20%',
    hasSort: true,
    getValue({ wire }) {
      return { value: wire.name, title: wire.name };
    },
  },
  {
    key: 3,
    name: 'wire_ref_id',
    header: 'WIRE ID',
    width: '15%',
    getValue({ wire }) {
      return { value: wire.ref_id, title: wire.ref_id };
    },
  },
  {
    key: 4,
    name: 'wire__type,-date_created',
    header: 'WIRE TYPE',
    width: '10%',
    hasSort: true,
    getValue({ wire }) {
      const wireType = WIRE_TYPE_SINGULAR_LABEL[wire.type];

      return { value: wireType, title: wireType };
    },
  },
  {
    key: 5,
    name: 'wire__is_pd_provider_kyc_required,-date_created',
    header: 'IDV',
    width: '5%',
    hasSort: true,
    getValue({ is_kyc_required }) {
      return { value: is_kyc_required ? <CheckedIcon /> : <DashedIcon /> };
    },
  },
  {
    key: 6,
    name: 'user__email,-date_created',
    header: 'BILLABLE USER',
    width: '20%',
    hasSort: true,
    getValue({ user }) {
      return { value: user.email, title: user.email };
    },
  },
  {
    key: 7,
    name: 'transaction__name,-date_created',
    header: 'TRANSACTION NAME',
    width: '15%',
    hasSort: true,
    getValue({ wire }) {
      const transactionName = wire.contract.name;

      return { value: transactionName, title: transactionName };
    },
  },
];
